import { Link } from "react-router-dom";
import { useState } from "react";
import ThemeToggle from "./ThemeToggle";
import { FaBars } from "react-icons/fa";

function Navbar() {

  const [open, setOpen] = useState(false);

  return (

    <header className="navbar">

      <div className="nav-container">

        {/* Logo */}

        <h2 className="logo">
          Cars<span>.</span>
        </h2>

        {/* Mobile Menu Icon */}

        <div
          className="menu-icon"
          onClick={() =>
            setOpen(!open)
          }
        >
          <FaBars />
        </div>

        {/* Navigation */}

        <nav
          className={`nav ${open ? "open" : ""}`}
        >

          <Link to="/">
            Home
          </Link>

          <Link to="/about">
            About
          </Link>

          <Link to="/cars">
            Cars
          </Link>

          <Link to="/contact">
            Contact
          </Link>

          {/* Theme Toggle */}

          <div className="theme-wrapper">
            <ThemeToggle />
          </div>

        </nav>

      </div>

    </header>

  );
}

export default Navbar;